<template>
    <v-autocomplete-custom
        v-model="inner_value"
        :label="label"
        :items="items"
        :multiple="multiple"
        :id="id"
        :popup-used-in-modal="popupUsedInModal"
        @update:search-input="updateSearch($event)"
        @click:append="createValue()"
        :search-input.sync="search"
        :append-icon="plusVisible ? 'fa-plus' : undefined"
        :disabled="disabled"
    >
        <!-- Selection slot -->
        <template v-slot:selection="data">
            <v-chip :disabled="data.item.disabled"
                    :input-value="data.selected"
                    close
                    close-icon="fas fa-circle-xmark"
                    small
                    v-bind="data.attrs"
                    @click:close="removeItem(data.item.value)">
                <span v-html="data.item.text" />
            </v-chip>
        </template>

        <!-- Item slot -->
        <template v-slot:item="{ active, item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-action>
                    <v-checkbox :input-value="attrs.inputValue"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        <span v-html="item.text"></span>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>

        <!-- No Data slot -->
        <template v-slot:no-data>
            <v-list-item>
                <v-list-item-content class="empty-message-list-item">
                    {{ t_no_data_available }}
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-autocomplete-custom>
</template>

<script>
import Template from "../../content/elements/template.vue";
import TableAutocompleteTag from "../../content/common/table/table-autocomplete-tag.vue";

export default {
    name: "AutocompleteAddable",
    components: {TableAutocompleteTag, Template},
    props: [
        "value",
        "items",
        "id",
        "disabled",
        "transNoResult",
        "transPlaceholderSingle",
        "transPlaceholderMulti",
        "label",
        "attach",
        "creatableValues",
        "multiple",
        "outlined",
        "dense",
        "hide-details",
        "popup-used-in-modal"
    ],
    data() {
        return {
            text_list: [],
            inner_value: [],
            plusVisible: false,
            search: "",
            t_no_data_available: Lang.langGet('No data available.').removeDotsAtEnd()
        };
    },
    watch: {
        value() {
            this.inner_value = JSON.parse(JSON.stringify(this.value));
        },
        inner_value() {
            if (JSON.stringify(this.inner_value) !== JSON.stringify(this.value)) {
                this.$emit("input", JSON.parse(JSON.stringify(this.inner_value)));
            }
        }
    },
    computed: {
        noResult() {
            if (typeof this.transNoResult !== "undefined") {
                return this.transNoResult;
            } else {
                return Lang.langGet("No results found");
            }
        },
        placeholderSingle() {
            if (typeof this.transPlaceholderSingle !== "undefined") {
                return this.transPlaceholderSingle;
            } else {
                return Lang.langGet("Select an option...");
            }
        },
        placeholderMulti() {
            if (typeof this.transPlaceholderMulti !== "undefined") {
                return this.transPlaceholderMulti;
            } else {
                return Lang.langGet("Select some options...");
            }
        }
    },
    methods: {
        updateSearch(search) {
            if (!this.creatableValues) {
                this.plusVisible = false;
                return;
            }

            if (!search) {
                this.plusVisible = this.items.length === 0;
                this.search = "";
                return;
            }

            this.search = search;
            const filteredList = this.items.filter(item => {
                return item.text.toLowerCase().includes(search.toLowerCase());
            });
            this.plusVisible = filteredList.length === 0;
        },
        createValue() {
            let search_text = this.search;
            if (typeof search_text !== "string" || search_text.length === 0) {
                return;
            }
            search_text = search_text.replace(/<[^>]*>?/gm, "");
            this.items.push({
                value: "#NEW-" + search_text,
                text: search_text
            });
            this.$nextTick(() => {
                this.inner_value.push("#NEW-" + search_text);
                this.plusVisible = false;
                this.search = "";
            });
        },
        resetInput() {
            this.$nextTick(() => {
                this.search = "";
            });
        },
        removeItem(itemValue) {
            this.inner_value = this.inner_value.filter(v => v !== itemValue);
        }
    },
    mounted() {
        this.inner_value = JSON.parse(JSON.stringify(this.value));
    }
};
</script>

<style>
.empty-message-list-item {
    font-style: italic;
    user-select: none;
    pointer-events: none;
}
</style>
